export default "__VITE_ASSET__DW$OBvug__"